import moment from "moment";
import { countryList, CountryType } from "./countryCodes";
export const getResidentPassInformation = (
  resident: any,
  beginDate?: string,
  endDate?: string,
  authorization?: any
) => {
  const rInfo = resident?.residencesInfo;
  const pName = authorization?.providerName;
  const pType = authorization?.providerType?.name;
  const name =
    authorization?.lotNumber ||
    (rInfo ? rInfo[0]?.lotInfo?.name : resident?.lotNumber || "");
  const rInfoDesc = rInfo && rInfo[0]?.lotInfo?.description;
  const rInfoPhone = rInfo && rInfo[0]?.lotInfo?.phone;
  const desc =
    rInfoDesc || rInfoPhone
      ? rInfoPhone
        ? (rInfoDesc ? rInfoDesc + " - " : "") + rInfoPhone
        : rInfoDesc
      : null;
  const fn = resident ? resident.firstname : "";
  const ln = resident ? resident.lastname : "";
  const phCel = resident ? resident.phone : "";
  const phPart = rInfo ? rInfo[0]?.landlineNumber : "";
  const getBeginDate = () => {
    if (beginDate) {
      return moment(beginDate).format("DD/MM/YYYY HH:mm");
    } else return "";
  };
  const getEndDate = () => {
    if (endDate) {
      return moment(endDate).format("DD/MM/YYYY HH:mm");
    } else return "";
  };
  const isOptionalParams = () => {
    if (beginDate || endDate)
      return "- (" + getBeginDate() + " - " + getEndDate() + ")";
    else return "";
  };
  return (
    (name ? name : "") +
    " " +
    (desc ? " - (" + desc + ") " : "") +
    (pName ? " - " + pName : "") +
    (pType ? " / " + pType : "") +
    (fn ? " - " + fn + " " : "") +
    (ln ? ln + ":" : "") +
    (phCel ? " Cel " + phCel + " " : "") +
    (phPart ? "/ Part " + phPart + " " : "") +
    isOptionalParams()
  );
};

export const queryParse = (resident: any) => {
  const name = resident?.residencesInfo
    ? resident?.residencesInfo[0]?.lotInfo?.name
    : resident?.lotNumber || "";
  const desc = resident?.residencesInfo
    ? resident.residencesInfo[0]?.lotInfo?.description
    : "";
  const fn = resident ? resident.firstname : "";
  const ln = resident ? resident.lastname : "";
  return `${name} ${desc} ${fn} ${ln}`;
};
export const dateParse = (
  date: string | Date,
  toFormat: string,
  fromFormat?: string
) => {
  return moment(date, toFormat).format(fromFormat ? fromFormat : toFormat);
};

export const isBefore = (date: string, equal?: boolean) => {
  const parse = moment(date, "DD-MM-YYYY");
  return equal
    ? parse.isSameOrBefore(moment(), "day")
    : parse.isBefore(moment(), "day");
};

export const controlDni = (dni: string, code: string) => {
  const v: number[] = [7, 3, 1];
  let i, n;
  for (i = n = 0; i < dni.length; i++) {
    const rest: any = dni[i];
    if (!isNaN(rest)) n += parseInt(dni[i], 10) * v[i % 3];
    else return false;
  }
  const lastDigit = n.toString().split("").pop();
  return lastDigit === code;
};
export const matchStringToNumber = (char: any) => {
  if (isNaN(char)) {
    if (char === "O" || char === "D") return "0";
    if (char === "I") return "1";
    if (char === "B") return "8";
    if (char === "S") return "5";
    if (char === "A") return "4";
    if (char === "G") return "6";
    if (char === "Z") return "2";
  }
  return char;
};

export const matchNumberToString = (char: any) => {
  if (!isNaN(char)) {
    if (char === "0") return "O";
    if (char === "1") return "I";
    if (char === "8") return "B";
    if (char === "5") return "S";
    if (char === "4") return "A";
    if (char === "6") return "G";
    if (char === "2") return "Z";
  }
  return char;
};

const replaceAt = (word: string, index: number, replacement: string) => {
  return (
    word.substr(0, index) +
    replacement +
    word.substr(index + replacement.length)
  );
};

export const matchValidateStringWord = (word: string) => {
  for (let i = 0; i < word.length; i++) {
    word = replaceAt(word, i, matchNumberToString(word[i]));
  }
  return word;
};

export const matchValidateNumberWord = (word: string) => {
  for (let i = 0; i < word.length; i++) {
    word = replaceAt(word, i, matchStringToNumber(word[i]));
  }
  return word;
};

export const matchCountryCode = (value: string): string => {
  let coincidences: CountryType[] = [];
  let filterCoincidences: CountryType[] = [];
  if (value.length === 3) {
    // for(let country in list){
    const countrySearch = countryList.find((country) => country.code === value);
    if (countrySearch) return countrySearch.code;
    countryList.forEach((country) => {
      for (let c = 0; c < 3; c++) {
        if (value[c] === country.code[c]) {
          const notExist =
            coincidences.find((finder) => finder.code === country.code) ===
            undefined;
          if (notExist) coincidences.push(country);
        }
      }
    });
    coincidences.forEach((country) => {
      for (let c = 0; c < 3; c++) {
        if (
          value[c] === country.code[c] &&
          value[(c + 1) % 3] === country.code[(c + 1) % 3]
        ) {
          filterCoincidences.push(country);
        }
      }
    });
  }
  if (filterCoincidences.length > 0) return filterCoincidences[0].code;
  else return "";
};
